import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
import InfiniteScrollWrapper from "react-infinite-scroll-component";
import { createContext, forwardRef, useContext } from "react";
import { Box, Center, Loader, useId } from "@coveord/plasma-mantine";
import classes from "./InfiniteScroll.module.css";
var InfiniteScrollContext = /*#__PURE__*/ createContext(null);
var InfiniteScrollProvider = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return _jsx(InfiniteScrollContext.Provider, {
        value: props,
        children: children
    });
};
var _InfiniteScroll = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    var id = useId();
    var infiniteScroll = useContext(InfiniteScrollContext);
    if (infiniteScroll === null) {
        throw new Error("InfiniteScroll must be wrapped by an InfiniteScroll.Provider");
    }
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({}, props), {
        className: clsx(classes.root, props.className),
        id: id,
        ref: ref,
        children: /*#__PURE__*/ _jsx(InfiniteScrollWrapper, _object_spread_props(_object_spread({
            loader: /*#__PURE__*/ _jsx(Center, {
                children: /*#__PURE__*/ _jsx(Loader, {})
            }),
            scrollableTarget: id
        }, infiniteScroll), {
            className: classes.scrollContainer,
            children: children
        }))
    }));
});
_InfiniteScroll.Provider = InfiniteScrollProvider;
_InfiniteScroll.displayName = "@components/mantine/InfiniteScroll";
export var InfiniteScroll = _InfiniteScroll;

//# sourceMappingURL=InfiniteScroll.js.map